import _slicedToArray from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { captureException } from '@sentry/nextjs';
import { useWeb3React } from '@web3-react/core';
import { BigNumber } from 'bignumber.js';
import { isAddress } from 'ethers/lib/utils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useUpdaterChainId } from "../../hooks";
import { FixedPointNumber } from "../../utils/fixedPoint";
import { useInterfaceMulticall } from "../../hooks/useContract";
import { useMultipleContractSingleData, useSingleContractMultipleData } from "../multicall/hooks";
import { ERC20Interface } from "../../constants/abi";
import { getChainById } from "../../utils/chain";
import { getBlocksPerFetchForChainId } from "../../utils/getBlocksPerFetchForChainId";
export var useETHBalance = function useETHBalance() {
  var withDecimal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var _useWeb3React = useWeb3React(),
      provider = _useWeb3React.provider,
      account = _useWeb3React.account;

  var expectChainId = useUpdaterChainId(); // 未获取到时为 undefined, 和 balance 为 0 区分开

  var _useState = useState(),
      ethBalance = _useState[0],
      setETHBalance = _useState[1];

  var getETHBalance = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var balance;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!provider || !account || !expectChainId)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return provider.getBalance(account);

          case 5:
            balance = _context.sent;
            setETHBalance(new BigNumber(balance.toString()));
            console.log('balance', balance.toString());
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            console.error('Failed to get ETH balance', _context.t0);
            captureException(_context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  })), [expectChainId, account, provider]);
  useEffect(function () {
    getETHBalance();
    return function () {
      setETHBalance(undefined);
    };
  }, [getETHBalance]);
  return withDecimal ? ethBalance : ethBalance === null || ethBalance === void 0 ? void 0 : ethBalance.shiftedBy(-18);
};
export var useNativeTokenBalances = function useNativeTokenBalances(uncheckedAccounts) {
  var expectChainId = useUpdaterChainId();
  var multicall = useInterfaceMulticall();
  var validAccounts = useMemo(function () {
    return uncheckedAccounts.map(function (r) {
      return isAddress(r) ? r : false;
    }).filter(function (r) {
      return r !== false;
    }).map(function (address) {
      return [address];
    });
  }, [uncheckedAccounts]);
  var results = useSingleContractMultipleData(multicall, 'getEthBalance', validAccounts);
  return useMemo(function () {
    return validAccounts.reduce(function (memo, _ref2, i) {
      var _results$i;

      var _ref3 = _slicedToArray(_ref2, 1),
          address = _ref3[0];

      var value = results === null || results === void 0 || (_results$i = results[i]) === null || _results$i === void 0 || (_results$i = _results$i.result) === null || _results$i === void 0 ? void 0 : _results$i[0];

      if (value && expectChainId) {
        memo[address] = new FixedPointNumber(value, 18);
      }

      return memo;
    }, {});
  }, [validAccounts, results, expectChainId]);
};
export var useNativeTokenBalance = function useNativeTokenBalance() {
  var _useNativeTokenBalanc;

  var _useWeb3React2 = useWeb3React(),
      account = _useWeb3React2.account;

  var balances = (_useNativeTokenBalanc = useNativeTokenBalances(account ? [account] : [])) === null || _useNativeTokenBalanc === void 0 ? void 0 : _useNativeTokenBalanc[account];
  return balances;
};
export var useTokenBalances = function useTokenBalances(account, tokens) {
  var _useWeb3React3 = useWeb3React(),
      chainId = _useWeb3React3.chainId;

  var validTokens = useMemo(function () {
    return tokens.filter(function (t) {
      return t && isAddress(t.address);
    });
  }, [tokens]);
  var validAddresses = useMemo(function () {
    return validTokens.map(function (t) {
      return t.address;
    });
  }, [validTokens]);
  var blocksPerFetch = useMemo(function () {
    return getBlocksPerFetchForChainId(chainId);
  }, [chainId]);
  var balances = useMultipleContractSingleData(validAddresses, ERC20Interface, 'balanceOf', [account], {
    blocksPerFetch: blocksPerFetch
  });
  var anyLoading = useMemo(function () {
    return balances.some(function (callState) {
      return callState.loading;
    });
  }, [balances]);
  return useMemo(function () {
    return validAddresses.reduce(function (memo, address, i) {
      var _balances$i;

      var value = balances === null || balances === void 0 || (_balances$i = balances[i]) === null || _balances$i === void 0 || (_balances$i = _balances$i.result) === null || _balances$i === void 0 ? void 0 : _balances$i[0];

      if (value) {
        memo[address] = new FixedPointNumber(value, Number(validTokens[i].decimals));
      }

      return memo;
    }, {});
  }, [account, anyLoading, balances, validAddresses, validTokens]);
};
export var useTokenBalance = function useTokenBalance(account, token) {
  var tokenBalances = useTokenBalances(account, [token]);
  if (!token) return undefined;
  return tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances[token.address];
};
export var useNativeCurrencySymbol = function useNativeCurrencySymbol() {
  var _useWeb3React4 = useWeb3React(),
      chainId = _useWeb3React4.chainId;

  return useMemo(function () {
    var chain = getChainById(chainId);
    return (chain === null || chain === void 0 ? void 0 : chain.nativeSymbol) || 'ETH';
  }, [chainId]);
};